import React, { useState, useMemo } from 'react';
import FilterSidebar from '../components/explore/FilterSidebar';
import AircraftGrid from '../components/explore/AircraftGrid';
import aircraftIndex from '../data/aircraft-index.json';

function ExplorePage() {
  const [activeFilters, setActiveFilters] = useState({
    manufacturers: [],
    countries: [],
    types: []
  });

  const handleFilterChange = (category, values) => {
    if (category === 'clear') {
      setActiveFilters({
        manufacturers: [],
        countries: [],
        types: []
      });
    } else {
      setActiveFilters(prev => ({
        ...prev,
        [category]: values
      }));
    }
  };

  // Filter aircraft based on active filters
  const filteredAircraft = useMemo(() => {
    let filtered = aircraftIndex.aircraft;

    if (activeFilters.manufacturers.length > 0) {
      filtered = filtered.filter(aircraft =>
        activeFilters.manufacturers.includes(aircraft.manufacturer)
      );
    }

    if (activeFilters.countries.length > 0) {
      filtered = filtered.filter(aircraft =>
        activeFilters.countries.includes(aircraft.country)
      );
    }

    if (activeFilters.types.length > 0) {
      filtered = filtered.filter(aircraft =>
        activeFilters.types.includes(aircraft.type)
      );
    }

    return filtered;
  }, [activeFilters]);

  return (
    <div className="explore-page">
      <div className="explore-container">
        <FilterSidebar
          filters={aircraftIndex.filters}
          activeFilters={activeFilters}
          onFilterChange={handleFilterChange}
        />

        <div className="explore-main">
          <div className="explore-header">
            <h1 className="explore-title">Explore Aircraft</h1>
            <p className="explore-subtitle">
              {filteredAircraft.length} {filteredAircraft.length === 1 ? 'aircraft' : 'aircraft'} available
            </p>
          </div>

          <AircraftGrid aircraft={filteredAircraft} />
        </div>
      </div>
    </div>
  );
}

export default ExplorePage;
